import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  wrapper: {
    height: 372,
    width: 264,
    margin: '0 auto',
    overflow: 'hidden',
  },
  thumbnail: {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(0.33)',
    height: 1128,
    width: 798,
    cursor: 'zoom-in',
  },
}));
